import { snackbar } from "@mobiscroll/react5";
import {
  REJECT_EMERGENCY_APPOINTMENT,
  ACCEPT_EMERGENCY_APPOINTMENT,
  READ_NOTIFICATION,
  ADD_TODO_LIST,
  SET_FOLLOW_UP,
} from "src/components/graphql/GraphQLmutation";
import { DOES_PATIENT_HISTORY_EXISTS } from "src/components/graphql/GraphQLquery";
import {
  getQueryWithParams,
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";

export async function listPatientHistory(patientId) {
  try {
    const response = await getQueryWithParams(
      DOES_PATIENT_HISTORY_EXISTS,
      patientId
    );

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to check patient history");
    }

    const result = response?.data?.listPatientHistory;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to check patient history");
    }
    
    // Success case
    if (result?.data && result.data.length > 0) {
      return true;
    }
    return false;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at listPatientHistory:", e);
    return false;
  }
}

export async function setFollowUp(data) {
  try {
    const response = await postMutation(SET_FOLLOW_UP, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to create follow-up");
    }

    const result = response?.data?.setFollowUp;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to create follow-up");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Follow-up appointment created successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at setFollowUp:", e);
    return false;
  }
}

export async function addToDoList(data) {
  try {
    const response = await postMutation(ADD_TODO_LIST, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add to-do list");
    }

    const result = response?.data?.addToDoNote;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add to-do list");
    }
    
    // Success case
    snackbar({
      message: result?.message || "To-do list added successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addToDoList:", e);
    return false;
  }
}

export async function rejectEmergencyAppointment(data) {
  try {
    const response = await postMutation(REJECT_EMERGENCY_APPOINTMENT, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to reject appointment");
    }

    const result = response?.data?.rejectEmergencyAppointment;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to reject appointment");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Appointment rejected successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at rejectEmergencyAppointment:", e);
    return false;
  }
}

export async function acceptEmergencyAppointment(data) {
  try {
    const response = await postMutation(ACCEPT_EMERGENCY_APPOINTMENT, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to accept appointment");
    }

    const result = response?.data?.acceptEmergencyAppointment;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to accept appointment");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Appointment accepted successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at acceptEmergencyAppointment:", e);
    return false;
  }
}
